import { ResolveFn } from '@angular/router';
import { MySocket, SocketService } from '../socket.service';
import { inject } from '@angular/core';

export const socketResolver: ResolveFn<MySocket> = async (route, state) => {
  const socketService = inject(SocketService);
  return await socketService.connect();
};
